import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import CloudFunctions from "@/api/cloudFunctions/CloudFunctions";
import { auth } from "@/api/firebase/firebase.config";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Heading } from "@radix-ui/themes";
import { toast } from "react-toastify";
import { Loader } from "@/components";
import i18next from "i18next";

interface Response {
  status: "success" | "failed";
  reason?: string; // if status is failed
  token?: string; //if status is success
}

export const AuthDiscordRedirect = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const [loading, setLoading] = useState<boolean>(false);
  const code = urlParams.get("code");
  const navigate = useNavigate();

  const handleAuth = async () => {
    setLoading(true);
    await CloudFunctions.callCloudFunction("authenticateWithDiscordCode", {
      discordCode: code,
      platform: brand.brandValue,
      tenantId: brand.tenantId,
      site_url: brand.site,
    })
      .then(async (response) => {
        if (response.token && response.status === "success") {
          await auth
            .signInWithCustomToken(response.token)
            .then((res) => {
              if (res?.user) {
                toast.success(i18next.t("auth.methods.discord.login.success"));
                return navigate("/");
              }
            })
            .catch(() => {
              toast.error(
                response.reason ||
                  i18next.t("auth.methods.discord.login.failed.token")
              );
              return navigate("/");
            });
        }
      })
      .catch((err) => {
        toast.error(i18next.t("auth.methods.discord.login.failed.auth"));
        return navigate("/");
      });

    return navigate("/");
  };

  useEffect(() => {
    if (!loading) {
      handleAuth();
    }
  }, []);

  return (
    <Loader>
      <Heading>{i18next.t("auth.methods.discord.login.loading")}</Heading>
    </Loader>
  );
};
